import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface StationState {
  selectedStationCode: string
  isStationSelectionLocked: boolean
  setSelectedStationCode: (stationCode: string) => void
  clearSelectedStationCode: () => void
  setStationSelectionLocked: (isLocked: boolean) => void
}

export const useStationStore = create<StationState>()(
  persist(
    (set) => ({
      selectedStationCode: '',
      isStationSelectionLocked: false,
      setSelectedStationCode: (stationCode) =>
        set({
          selectedStationCode: stationCode,
        }),
      clearSelectedStationCode: () =>
        set({
          selectedStationCode: '',
        }),
      setStationSelectionLocked: (isStationSelectionLocked) => set({ isStationSelectionLocked }),
    }),
    {
      name: 'rrms-station-store',
      partialize: (state) => ({
        selectedStationCode: state.selectedStationCode,
      }),
    }
  )
)

export const selectSelectedStationCode = (state: StationState) => state.selectedStationCode
export const selectIsStationSelectionLocked = (state: StationState) =>
  state.isStationSelectionLocked
